var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10h5V9h-5v1zm7.5 2.5v.5h1v-.5h-1zm-.5 1h-9v1h9v-1zM3 13v-.5H2v.5h1zm.5.5A.5.5 0 013 13H2a1.5 1.5 0 001.5 1.5v-1zM13 13a.5.5 0 01-.5.5v1A1.5 1.5 0 0014 13h-1zm-2.5-3a2.5 2.5 0 012.5 2.5h1A3.5 3.5 0 0010.5 9v1zm-5-1A3.5 3.5 0 002 12.5h1A2.5 2.5 0 015.5 10V9z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan1.61f97461.svg";
export { SvgTongyongRenyuan1 as ReactComponent };